module.exports = __webpack_public_path__ + "img/恩裳logo图.d4ebc3be.png";